import { Row, Tooltip } from "antd";
import queryString from "query-string";
import React, { useEffect, useState } from "react";
import Workbook from "react-excel-workbook";
import Highlighter from "react-highlight-words";
import PrintComponents from "react-print-components";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import exportIcon from "../../../../../../assets/icons/export.svg";
import printIcon from "../../../../../../assets/icons/print.svg";
import {
  milliToDate,
  dateFormatter,
  checkIEBrowser,
  recordError,
  todayDate,
  changeAllShareAllPoolStatus
} from "../../../../../../utils/commonUtil";
import { getPrimaryAccount } from "../../../../../../utils/sessionUtil";
import { IconsPlaceNew } from "../../../../../Investments/Pages/InvestmentOptionDetails/styles";
import { enableRegrant } from "../../../RecommendGrant/actions";
import {
  cancelTxnSchedule,
  fetchGrantData,
  selectGAtab,
  setCSRBusinessData,
  updateSingleGrants,
  showGaLoader,
  setAllSingleGrants
} from "../../actions";
import { AlertMessagePrimary } from "../AlertPopUp/AlertPopUp";
import TabsComponent from "../TabLayout/TabsComponent";
import ContentPrinter from "./ContentPrinter";
import PurposeSummary from "../../../../Components/PurposeSummary/PurposeSummary";
import {
  DataExportPrint,
  IconPadding,
  StyleLessButtons,
  TableData,
  GrantActionTitle,
  GrantActionItems,
  TitleData,
  UnderLinePurposeLink  
} from "./style";
import CheckRegrantOptions from "./Regrant";
import { compareByAlph, renderAmount, WarningContent } from "./utilities";
import { checkCSRBusinessFunction } from "../../../../../../CSR/utils/CommonUtils";
import { BUSINESS_FUNCTION } from "../../../../../../CSR/utils/csrBusinessFunctionMapper";
import { analyticsTracking } from "../ContentComponent/analytics";
import { DataValueWrapper } from "../../../../../../CommonComponents/commonStyles";
import tableIcon from "../../../../../../assets/icons/table-action-button.png";
import infoIcon from "../../../../../../assets/icons/shape.svg";
import history from "../../../../../../history/history";
import { withContents } from "../../../../../../CommonComponents/ContentMessages";
import { getAlertDescForActivity, getAlert } from "../../../../../NPA/Pages/Step1Setup/Components/UtilFunctions";
import { MenuContentWrapper } from "../../../../../../CommonComponents/commonStyles";
import  PropTypes from 'prop-types';
import { ContentComponentDerivedStates } from "../../selectors";
import { exportExcelTableData } from "../../../../../../services/apiServices";
import Preloader from "../../../../../../CommonComponents/Preloader/Preloader";
import { isEmpty, orderBy } from "lodash";


export const csrBusinessWithtabPane = tabIndex => {
  let csrBusiness = [];

  switch (tabIndex) {
    case "1":
      csrBusiness = ["DONOR_PORTAL_EDIT_SINGLE_GRANT_FULL_ACCESS"];
      break;
    case "2":
      csrBusiness = [
        "DONOR_PORTAL_EDIT_RECURRING_GRANT_SCHEDULE_FULL_ACCESS"
      ];
      break;
    default:
      return csrBusiness;
  }
  return csrBusiness;
};

export const getSortValues = (a='', toLower=false) => {    
  if(a) {
    if(!toLower) {
      return a.grantAgreementFlag ? 'Grant Agreement': (a.isRecurring === true ? 'Recurring': 'One Time');
    } else {
      return a.grantAgreementFlag ? ('Grant Agreement').toLowerCase(): (a.isRecurring === true ? ('Recurring').toLowerCase(): ('One Time').toLowerCase());
    }
  }
  return;
}

export function ContentComponent(props) {
  const agreementCTA = true;
  const [popup, setPopup] = useState(false);
  const [scheduleId, setSelectedschedule] = useState("");
  const [printerData, setPrinterData] = useState([]);
  const [cancelContent, setCancelContent] = useState(WarningContent.single);
  const [recurringPopup, setRecurringPopup] = useState(false);
  const [txnId, setSelectedTxn] = useState("");
  const [tabIndex, setTabIndex] = useState("1");
  const [search, setSearch] = useState("");
  const [alertStatus, setAlertStatus] = useState(false);
  const [singleAlert, setSingleAlert] = useState({});
  const [spawnAlert, setSpawnAlert] = useState({});
  const [recurringAlert, setRecurringAlert] = useState({});
  const [csrBusinessFunctionItems, setCsrBusinessFunctionItems] = useState([
    "DONOR_PORTAL_EDIT_SINGLE_GRANT_FULL_ACCESS"
  ]);
  const [sortedInfo, setSortedInfo] = useState({});
  const [needSingleGrantUpdate, setNeedSingleGrantUpdate] = useState(false);

  const [singleTabData_1, setsingleTabData_1] = useState(props.singleData.singleGrants || []);
  const [recurringTabData_2, setRecurringTabData_2] = useState(props.recurringData.recurringGrant || []);
  const [agreementTabData_3, setAgreementTabData_3] = useState(props.agreementsData || []);

  
  useEffect(()=> {
    setsingleTabData_1(props.singleData.singleGrants);
  }, [JSON.stringify(props.singleData)])
  
  useEffect(()=> {
    setRecurringTabData_2(props.recurringData.recurringGrant);
  }, [JSON.stringify(props.recurringData)])

  useEffect(()=> {
    setAgreementTabData_3(props.agreementsData);
  }, [JSON.stringify(props.agreementsData)]);

  useEffect(()=> {
    if(props.avail){
      allSingleGrants();
    }
  },[props.avail]);

  const allSingleGrants = () => {
    props.setAllSingleGrants({
      method: "GET",
      url: `/donor-portal/api/grant/${
        getPrimaryAccount().userId
      }/findSingleGrantByAccountIdStartDateAndEndDate?startDateStr=10/10/1971&&endDateStr=${todayDate()}&isExport=true&pageStart=0&pageSize=3000`,
      page: "grantsActivity"
    });
  }

  useEffect(()=> {
    const {allSingleGrants, singleGrants} = props.singleData;
    if(props.avail && allSingleGrants){
      let allSingleGrantSorted = allSingleGrants;
      if(!isEmpty(sortedInfo)) {
        const { order, columnKey } = sortedInfo;
        // As per current behaviour
        const sortMapper = {
          ascend: 'desc',
          descend: 'asc'
        }
        allSingleGrantSorted = orderBy(allSingleGrants, [columnKey], [sortMapper[order]]);
      }
      setsingleTabData_1(allSingleGrantSorted);
    }

    if(props.avail && needSingleGrantUpdate && allSingleGrants && allSingleGrants.length !== singleGrants.length){
      props.updateSingleGrants(allSingleGrants);
      setNeedSingleGrantUpdate(false); 
    }

  },[props.singleData.allSingleGrants]);

  const exportGrantsTable = (tabIndex) => {
    let url;
    let filename;
    let params;
    let baseUri = `/donor-portal/api/grant/${getPrimaryAccount().userId}`
    analyticsTracking("export", tabIndex);

    switch(tabIndex) {
      case "1": 
        url = `${baseUri}/exportSingleGrantActivity`;
        params = singleTabData_1;
        filename = 'Grant Activity.xlsx';
        break;
      case "2":
        url = `${baseUri}/exportRecurringGrant`;
       // params = recurringTabData_2;
        filename = 'Recurring Grant Activity.xlsx';
        break;
      case "3":
        url = `/donor-portal/api/grantAgreement/${getPrimaryAccount().userId}/exportGrantAgreement`;
        params = agreementTabData_3;
        filename = 'Grant Agreement Activity.xlsx';
        break;
   }
    return exportExcelTableData(url, params, filename)
  };

  const getDataSource = (currentData) => {
    setTabDataForExport(currentData)
  }
  
  useEffect(() => {
    setSearch("");
    setPrinterData([]);
  }, [tabIndex, props.lazyLoaded, props.lazyLodedRec]);

  useEffect(() => {
    if(props.grantTab) {
      setTabIndex(props.grantTab)
    }
  }, [props.grantTab]);

  const setPrinter = data => {
    setPrinterData(data);
  };

  useEffect(() => {
    props.setCSRBusinessData(csrBusinessFunctionItems);
  }, [csrBusinessFunctionItems]);

  const checkUpdate = () => {
    if (props.lazyLoaded)
    return props.lazyLoaded && props.singleData.singleGrants.length;
    else return false;
  };

  const checkUpdateRec = () => {
    if (props.lazyLodedRec)
    return props.lazyLodedRec &&  props.recurringData.recurringGrant && props.recurringData.recurringGrant.length;
    else return false;
  };

  const highlighter = search => {
    setSearch(search);
  };

  const setTabDataForExport = (tabDataSource) => {
    switch(tabIndex){
      case "1":
        setsingleTabData_1(tabDataSource);
        break
      case "2":
        setRecurringTabData_2(tabDataSource);
        break
      case "3":
        setAgreementTabData_3(tabDataSource);
        break
      default:
        setsingleTabData_1(tabDataSource);
    }
  }

  const columnOnChange = (sorter, extra) => {    
    const { avail } = props;
    setSortedInfo(sorter)
    setTabDataForExport(extra.currentDataSource)

    if(tabIndex !== "1" || !avail) {
      return null;
    }

    setNeedSingleGrantUpdate(true);
    props.showGaLoader();
  }

  const renderValues = (value, row) => {
    const options = ["entered", "active"];
    if (
      value &&
      options.indexOf(value.toLowerCase()) > -1 &&
      props.user.role.access === "All Access"
    ){
      return (
        <>
          <MenuContentWrapper data-test = 'test'>
            <GrantActionItems
              onClick={() =>
                viewGrants(row.scheduleId, "recurring", null, "viewEdit")
              }>
              View & Edit
              </GrantActionItems>
          </MenuContentWrapper>
          <MenuContentWrapper>
            <GrantActionItems
              onClick={() => {
                handleRecuringPopup(row.scheduleId);
              }}
              disabled={checkCSRBusinessFunction(
                BUSINESS_FUNCTION[csrBusinessFunctionItems[0]],
                props.csrBusinessFunction
              )}
            >
              Cancel Transaction
              </GrantActionItems>
          </MenuContentWrapper>
        </>
      );
    } else
      return (
        <MenuContentWrapper>
          <GrantActionItems
            onClick={() =>
              viewGrants(row.scheduleId, "recurring", null, "view")
            }
          >
            View
          </GrantActionItems>
        </MenuContentWrapper>
      );
  }

  const renderGrantValues = (value, row) => {
    let clearedDate = row.checkClearedDate;
    const options = [
      "entered",
      "research proceeding"
    ];
    const regrant = ["payment issued", "payment completed"];
    if (row.grantAgreementFlag) {
      return (
        <MenuContentWrapper>       
          <GrantActionItems
            onClick={() =>
              viewGrants(row.txnId, "agreement", row.grantAgreementFlag, clearedDate)
            }
          >
            View
          </GrantActionItems>
        </MenuContentWrapper>        
      );
    } else if (
      row.status &&
      options.indexOf((row.status).toLowerCase()) > -1 &&
      props.user.role.access === "All Access"
    ) {
      return (
        <>
          <MenuContentWrapper>
            <GrantActionItems
                onClick={() =>
                  viewGrants(
                    row.txnId,
                    "single",
                    row.isRecurring,
                    "viewEdit",
                    clearedDate
                  )
                }>
              View & Edit
            </GrantActionItems>
          </MenuContentWrapper>
          <MenuContentWrapper>
            <GrantActionItems data-test = "GrantActionItems"
              onClick={() => {
                handlePop(row.txnId, row.isRecurring);
              }}
              disabled={checkCSRBusinessFunction(
                BUSINESS_FUNCTION[csrBusinessFunctionItems[0]],
                props.csrBusinessFunction
              )}
            >
              {props.cancel && row.status == "Cancelled" ? null : (
                <>Cancel Transaction</>
              )}

            </GrantActionItems>
          </MenuContentWrapper>
        </>
      );
    } else {
      return (
        <>
          <MenuContentWrapper>
            <GrantActionItems
              onClick={() =>
                viewGrants(row.txnId, "single", row.isRecurring, "view", clearedDate)
              }
            >
              View
            </GrantActionItems>
          </MenuContentWrapper>          
          {row.status &&
            regrant.indexOf(row.status.toLowerCase()) > -1 &&
            props.user.role.access === "All Access" ? (
              <MenuContentWrapper>
                <CheckRegrantOptions
                  txnId={row.txnId}
                  amount={row.amount}
                  history={props.history}
                  isRecurring={row.isRecurring}
                  setRegrant={props.enableRegrant}
                  charityName={row.charityName}
                  availableBalance={row.availableBalance}
                  fetchGrantData={props.fetchGrantData}
                />
              </MenuContentWrapper>
            ) : (
              row.isRecurring &&
              options.indexOf((row.status).toLowerCase()) > -1 &&
              props.user.role.access === "All Access" && (
                <MenuContentWrapper>
                  <GrantActionItems
                    wid30
                    onClick={() => {
                      handlePop(row.txnId, row.isRecurring);
                    }}
                  >
                    Cancel Transaction
                  </GrantActionItems>
                </MenuContentWrapper>
              )
            )}
        </>
      );
    }
      
  }

  const renderGAValues = (value, record) => {

    return (
      <MenuContentWrapper>
        <GrantActionItems
          onClick={() => {
            try {
              props.history.push(`/grants/grants-agreement/view?grantId=${record.grantAgreementId}`);
            } catch (error) {
              recordError(error);
            }
          }}
        >
          View
        </GrantActionItems>
      </MenuContentWrapper>
    );

  }



  //Tab swithing and resetting
  function tabController(tabIndexs) {
    setTabIndex(tabIndexs);
    analyticsTracking("tab", tabIndexs);
    setSearch("");
    props.setTab(tabIndexs);
    setCsrBusinessFunctionItems(csrBusinessWithtabPane(tabIndexs));
  }

  function handlePop(id, type) {
    try {
      setCancelContent(getAlertDescForActivity(props.contents,'Single'));
      setPopup(!popup);
      setSelectedTxn(id);
      changeAllShareAllPoolStatus();
    } catch (error) {
      recordError(error);
    }
  }

  function handleRecuringPopup(id) {
    try {
      setRecurringPopup(!recurringPopup);
      setSelectedschedule(id);
    } catch (error) {
      recordError(error);
    }
  }

  function CancelRecurring() {
    analyticsTracking("cancel", tabIndex);
    setRecurringPopup(!recurringPopup);
    props.cancelTxnSchedule({
      method: "PUT",
      page: "grantsActivity",
      url: `/donor-portal/api/grant/${getPrimaryAccount().userId}/cancelGrant`,
      data: {
        accountId: getPrimaryAccount().userId,
        scheduleId: scheduleId,
        grantType: "recurring"
      }
    });
  }
  function CancelSchedule() {
    setPopup(!popup);
    analyticsTracking("cancel", tabIndex);
    props.cancelTxnSchedule({
      method: "PUT",
      page: "grantsActivity",
      url: `/donor-portal/api/grant/${getPrimaryAccount().userId}/cancelGrant`,
      data: {
        accountId: getPrimaryAccount().userId,
        grantId: txnId,
        grantType: "single"
      }
    });
  }

  const viewGrants = (id, type, isSpawn = false, btnType, checkClearedDate) => {
    try {
      if (btnType === "viewEdit") {
        analyticsTracking("viewEdit", tabIndex);
      } else {
        analyticsTracking("view", tabIndex);
      }
  
      if (type === "single") {
        props.history.push({
          pathname: "/grants/activity/view",
          search: queryString.stringify({ grantId: id }),
          state: { isSpawn, checkClearedDate }
        });
      } else if (type === "agreement") {
        props.history.push({
          pathname: "/grants/activity/view",
          search: queryString.stringify({ grantId: id }),
          state: { isSpawn, checkClearedDate }
        });
      } else {
        props.history.push(`/grants/activity/view?scheduleId=${id}`);
      }
    } catch (error) {
      recordError(error);
    }
  };

  const tabContent = () => {
    let grants = {
      title: "Grants",
      key: 1,
      text: "No grants found.",
      columnConfig: [
        {
          title: () => <TitleData>Action
            <Tooltip              
              placement="right"
              title={<p>Click to see more actions for transactions</p>}
            >
              <span className="infotooltip">
                <img src={infoIcon} alt = "infoIcon"/>
              </span>
            </Tooltip>
          </TitleData>,
          render: (value, row) => {
            const options = ["entered", "active"];
            return (
              <GrantActionTitle>
                <Tooltip overlayClassName="exchangeTooltip" placement="bottom" title={renderGrantValues(value, row)}>
                  <img src={tableIcon} alt = "tableIcon"/>
                </Tooltip>
              </GrantActionTitle>
            )
          },
         width: 100
        },
        {
          title: () => <TitleData break>Charity Name</TitleData>,
          dataIndex: "charityName",
          key: "charityName",
          render: (value, row, index) => {
            return value !== "" ? (
              <TableData ie={checkIEBrowser()}>
                {value ? (
                  <>
                    <Highlighter
                      id={`grant-hightlighter-${index}`}
                      highlightStyle={{
                        color: "black",
                        fontWeight: 600,
                        backgroundColor: "transparent"
                      }}
                      searchWords={[search]}
                      autoEscape={true}
                      textToHighlight={value && value.toString()}
                    />
                  </>
                ) : (
                    <div>&mdash;</div>
                  )}
              </TableData>
            ) : (
                <TableData>&mdash;</TableData>
              );
          },
          width: 100,
          sortDirections: ["ascend", "descend"],
          sorter: (a, b) => compareByAlph(a.charityName, b.charityName),
          sortOrder: sortedInfo.columnKey === 'charityName' && sortedInfo.order,
        },
        {
          title: () => <TitleData>Amount</TitleData>,
          dataIndex: "amount",
          key: "amount",
          render: value => {
            return value !== "" ? (
              <TableData textAlign="right" break>
                {value ? renderAmount(value) : <div>&mdash;</div>}
              </TableData>
            ) : (
                <TableData> -- </TableData>
              );
          },
          width: 100,
          sortDirections: ["ascend", "descend"],
          sorter: (a, b) => compareByAlph(a.amount, b.amount),
          sortOrder: sortedInfo.columnKey === 'amount' && sortedInfo.order,
        },
        {
          title: () => <TitleData>Purpose</TitleData>,
          dataIndex: "purpose",
          key: "purpose",
          render: (value, row) => {
            const purpose = {
              eventName: row.eventName,
              missionaryName: row.missionaryName,
              missionaryLocation: row.missionaryLocation,
              projectName: row.projectName,
              additionalComments: row.additionalComments
            };

            return value ? (              
                <DataValueWrapper>
                  <Tooltip title={<PurposeSummary {...purpose} />} placement="bottom">
                    <UnderLinePurposeLink showCursor><TitleData ie={checkIEBrowser()}>{value}</TitleData></UnderLinePurposeLink>
                  </Tooltip>                  
                </DataValueWrapper>              
            ) : (
                <TableData> &mdash; </TableData>
              );
          },
          width: 100,
          sortDirections: ["ascend", "descend"],
          sorter: (a, b) => compareByAlph(a.purpose, b.purpose),
          sortOrder: sortedInfo.columnKey === 'purpose' && sortedInfo.order,
        },
        {
          title: () => <TitleData>Schedule Type</TitleData>,
          dataIndex: "isRecurring",
          key: "isRecurring",
          render: (value, row) => <TableData>{getSortValues(row)}</TableData>,
          width: 100,
          sortDirections: ["ascend", "descend"],
          sorter: (a, b) => compareByAlph(getSortValues(a, true), getSortValues(b, true)),
          sortOrder: sortedInfo.columnKey === 'isRecurring' && sortedInfo.order,
        },
        {
          title: () => <TitleData>Scheduled
            <Tooltip
              className="scheduledInfo"
              placement="bottom"
              title={<p>The date the donor requested the grant to be issued. Donors have the option to request a date or send as soon as possible.</p>}>        
              <span className="infotooltip">
                <img src={infoIcon} alt = "infoIcon"/>
              </span>
            </Tooltip>
          </TitleData>,
          dataIndex: "dateRequested",
          key: "dateRequested",
          render: value => {
            return value !== "" ? (
              <TableData break>
                {value ? milliToDate(value) : <div>&mdash;</div>}{" "}
              </TableData>
            ) : (
                <TableData> -- </TableData>
              );
          },
          width: 100,
          sortDirections: ["ascend", "descend"],
          sorter: (a, b) => compareByAlph(a.dateRequested, b.dateRequested),
          sortOrder: sortedInfo.columnKey === 'dateRequested' && sortedInfo.order,
        },
        {
          title: () => <TitleData>Issued</TitleData>,
          dataIndex: "issuedate",
          key: "issuedate",
          render: value => {
            return value !== "" ? (
              <TableData break>
                {value ? milliToDate(value) : <div>&mdash;</div>}{" "}
              </TableData>
            ) : (
                <TableData> -- </TableData>
              );
          },
          width: 100,
          sortDirections: ["ascend", "descend"],
          sorter: (a, b) => compareByAlph(a.issuedate, b.issuedate),
          sortOrder: sortedInfo.columnKey === 'issuedate' && sortedInfo.order,
        },
        {
          title: () => <TitleData>Status</TitleData>,
          dataIndex: "status",
          key: "status",
          render: (value,row) => {
            return value !== "" ? (
              <TableData break>{value} </TableData>
            ) : (
                <TableData> &mdash; </TableData>
              );
          },
          width: 100,
          sortDirections: ["ascend", "descend"],
          sorter: (a, b) => compareByAlph(a.status, b.status),
          sortOrder: sortedInfo.columnKey === 'status' && sortedInfo.order,
        }
      ]
    };

    let schedules = {
      title: "View & Edit Grant Schedule",
      key: 2,
      text: "No schedules found.",
      columnConfig: [
        {
          title: () => <TitleData>Action
            <Tooltip
              placement="right"
              title={<p>Click to see more actions for transactions</p>}
            >
              <span className="infotooltip">
                <img src={infoIcon} alt = "infoIcon"/>
              </span>
            </Tooltip>
          </TitleData>,
          render: (value, row) => {
            const options = ["entered", "active"];
            let toolTipWidth = (value.status && options.indexOf(value.status.toLowerCase()) > -1 && props.user.role.access === "All Access")
            return (
              <GrantActionTitle>
                <Tooltip overlayClassName="exchangeTooltip" placement="bottom" title={renderValues(value.status, row)}>
                  <img src={tableIcon} alt = "tableIcon"/>
                </Tooltip>
              </GrantActionTitle>
            )
          },
          width: 100
        },
        {
          title: () => <TitleData>Entered</TitleData>,
          dataIndex: "enteredDate",
          key: "enteredDate",
          render: value => {
            return (
              <TableData break>
                {value ? milliToDate(value) : <div>&mdash;</div>}{" "}
              </TableData>
            );
          },
          width: 100,
          sortDirections: ["ascend", "descend"],
          sorter: (a, b) => compareByAlph(a.enteredDate, b.enteredDate)
        },
        {
          title: () => <TitleData break>Charity Name</TitleData>,
          dataIndex: "granteeOrg",
          key: "granteeOrg",
          render: value => {
            return value.legalName !== "" ? (
              <TableData ie={checkIEBrowser()}>
                {value.legalName ? (
                  <>
                    <Highlighter
                      highlightStyle={{
                        color: "black",
                        fontWeight: 600,
                        backgroundColor: "transparent"
                      }}
                      searchWords={[search]}
                      autoEscape={true}
                      textToHighlight={value && value.legalName.toString()}
                    />
                  </>
                ) : (
                    <div>&mdash;</div>
                  )}
              </TableData>
            ) : (
                <TableData> &mdash; </TableData>
              );
          },
          width: 100,
          sortDirections: ["ascend", "descend"],
          sorter: (a, b) =>
            compareByAlph(a.granteeOrg.legalName, b.granteeOrg.legalName)
        },
        {
          title: () => <TitleData>Amount</TitleData>,
          dataIndex: "grantAmount",
          key: "grantAmount",
          render: value => {
            return value !== "" ? (
              <TableData>{value} </TableData>
            ) : (
                <TableData> &mdash; </TableData>
              );
          },
          width: 100,
          sortDirections: ["ascend", "descend"],
          sorter: (a, b) => compareByAlph(a.grantAmount, b.grantAmount)
        },
        {
          title: () => (
            <TitleData break>
              Remaining
              <br /> Payments
            </TitleData>
          ),
          dataIndex: "remainingPayments",
          key: "remainingPayments",
          render: value => {
            return value !== "" ? (
              <TableData>
                &nbsp;
                {value != 0 ? (
                  value < 10 ? (
                    "0" + value
                  ) : (
                      value
                    )
                ) : (
                    <div>&mdash;</div>
                  )}
              </TableData>
            ) : (
                <TableData> &mdash; </TableData>
              );
          },
          width: 100,
          sortDirections: ["ascend", "descend"],
          sorter: (a, b) =>
            compareByAlph(a.remainingPayments, b.remainingPayments)
        },
        {
          title: () => <TitleData break>Frequency</TitleData>,
          dataIndex: "frequency",
          key: "frequency",
          render: (value, row) => {
            return value ? (
              (milliToDate(row.nextScheduledDate) === "Invalid date" ? (
                <TableData>{value}&nbsp; </TableData>
              ) : (
                <TableData>
                    <DataValueWrapper>
                      <Tooltip title={`Next scheduled on ${milliToDate(row.nextScheduledDate)}`} placement="bottom">
                        <UnderLinePurposeLink showCursor>{value}</UnderLinePurposeLink>
                      </Tooltip>                      
                    </DataValueWrapper>
                  </TableData>
                ))) :
              (
                <TableData> &mdash; </TableData>
              );
          },
          width: 100,
          sortDirections: ["ascend", "descend"],
          sorter: (a, b) => compareByAlph(a.status, b.status)
        },
        {
          title: () => <TitleData>Status</TitleData>,
          dataIndex: "status",
          key: "status",
          render: value => {
            return value !== "" ? (
              <Tooltip placement="bottomRight" title={value} trigger="click">
                <TableData break>{value} </TableData>
              </Tooltip>
            ) : (
                <TableData> &mdash; </TableData>
              );
          },
          width: 100,
          sortDirections: ["ascend", "descend"],
          sorter: (a, b) => compareByAlph(a.status, b.status)
        }
      ]
    };

    let agreements = {
      title: "Grant Agreements",
      key: 3,
      text: "No agreements found.",

      columnConfig: [
        {
          title: () => <TitleData>Action
            <Tooltip
              placement="right"
              title={<p>Click to see more actions for transactions</p>}
            >
              <span className="infotooltip">
                <img src={infoIcon} alt = "infoIcon"/>
              </span>
            </Tooltip>
          </TitleData>,
          render: (value, record) => {
            return (
              <GrantActionTitle>
                <Tooltip overlayClassName={'exchangeTooltip'} placement="bottom" title={renderGAValues(value, record)}>
                  <img src={tableIcon} alt =  "tableIcon"/>
                </Tooltip>
              </GrantActionTitle>
            )
          },
          width: 100
        },
        {
          title: () => <TitleData>Grant Term</TitleData>,
          dataIndex: "gaStartDate",
          key: "gaStartDate",
          render: (value, row) => {
            return (
              <TableData>
                {value ? (
                  [
                    dateFormatter(value),
                    <br />,
                    "to",
                    <br />,
                    dateFormatter(row.gaEndDate)
                  ]
                ) : (
                    <>&mdash;</>
                  )}
              </TableData>
            );
          },
          width: 100,
          sortDirections: ["ascend", "descend"],
          sorter: (a, b) => compareByAlph(a.gaStartDate, b.gaStartDate) //Grant Term SORTing
        },
        {
          title: () => <TitleData break>Charity Name</TitleData>,
          dataIndex: "charityName",
          key: "charityName",
          render: value => {
            return value !== "" ? (
              <TableData ie={checkIEBrowser()}>
                {value ? (
                  <>
                    <Highlighter
                      highlightStyle={{
                        color: "black",
                        fontWeight: 600,
                        backgroundColor: "transparent"
                      }}
                      searchWords={[search]}
                      autoEscape={true}
                      textToHighlight={value && value.toString()}
                    />
                  </>
                ) : (
                    <div>&mdash;</div>
                  )}
              </TableData>
            ) : (
                <TableData> -- </TableData>
              );
          },
          width: 100,
          sortDirections: ["ascend", "descend"],
          sorter: (a, b) => compareByAlph(a.charityName, b.charityName)
        },
        {
          title: () => (
            <TitleData>
              Total Agreement
              <br />
              Amount
            </TitleData>
          ),
          dataIndex: "grantAgreementAmount",
          key: "grantAgreementAmount",
          render: value => {
            return value !== "" ? (
              <TableData>
                {"$" + value ? renderAmount(value) : <div>&mdash;</div>}
              </TableData>
            ) : (
                <TableData> -- </TableData>
              );
          },
          width: 100,
          sortDirections: ["ascend", "descend"],
          sorter: (a, b) =>
            compareByAlph(a.grantAgreementAmount, b.grantAgreementAmount)
        },
        {
          title: () => <TitleData>Purpose</TitleData>,
          dataIndex: "purpose",
          key: "purpose",
          render: value => {
            return value !== "" ? (              
              <DataValueWrapper>
                <Tooltip title={<PurposeSummary {...value} />} placement="bottom">
                  <UnderLinePurposeLink showCursor><TitleData ie={checkIEBrowser()}>{value.description}</TitleData></UnderLinePurposeLink>
                </Tooltip>                
              </DataValueWrapper>              
            ) : (
                <TableData> &mdash; </TableData>
              );
          },
          width: 100,
          sortDirections: ["ascend", "descend"],
          sorter: (a, b) =>
            compareByAlph(a.purpose.description, b.purpose.description)
        },
        {
          title: () => <TitleData>No. of Payments</TitleData>,
          dataIndex: "noOfPayments",
          key: "noOfPayments",
          render: (value, row) => {
            return value !== "" ? (
              <TableData>
                &nbsp;
                {value != 0 && (
                  <>
                    {value < 9 ? (
                      <>
                        {[
                          <>
                            {row.pendingPayments < 9 ? (
                              <>{["0", row.pendingPayments, " ", "of", " "]}</>
                            ) : (
                                row.pendingPayments
                              )}
                          </>,
                          "0",
                          value,
                          " "
                        ]}
                      </>
                    ) : (
                        value
                      )}
                  </>
                )}
              </TableData>
            ) : (
                <TableData> &mdash; </TableData>
              );
          },
          width: 100,
          sortDirections: ["ascend", "descend"],
          sorter: (a, b) => compareByAlph(a.noOfPayments, b.noOfPayments)
        },
        {
          title: () => <TitleData>Status</TitleData>,
          dataIndex: "status",
          key: "status",

          render: value => {
            return value !== "" ? (
              <TableData break>{value.description} </TableData>
            ) : (
                <TableData> &mdash; </TableData>
              );
          },
          width: 100,
          sortDirections: ["ascend", "descend"],
          sorter: (a, b) =>
            compareByAlph(a.status.description, b.status.description)
        }
      ]
    };


    return { grants, schedules, agreements };
  };


  useEffect(() => {
    if(props.contents && !alertStatus){
      setCancelContent(getAlertDescForActivity(props.contents,'Single'));
      setSingleAlert(getAlert(props.contents,'Single'));
      setSpawnAlert(getAlert(props.contents,'Spawns'));
      setRecurringAlert(getAlert(props.contents,'Recurring'));
      setAlertStatus(true);
    }
  });
  return (
    <div>
      <div id="mobileModal"></div>
      <AlertMessagePrimary
        data-test="alertMessagePrimary1"
        className="artCancelSchedule"
        title={(singleAlert && singleAlert.length && singleAlert[0].field_header) ||"Cancel"}
        visible={popup}
        onOk={() => CancelSchedule()}
        onCancel={() => setPopup(!popup)}
        cancelText={ (singleAlert  && singleAlert.length && singleAlert[0].field_alert_button2_text) ||"No, take me back"}
        okText={ (singleAlert  && singleAlert.length && singleAlert[0].field_alert_button1_text) ||"CONTINUE"}
      >
        {cancelContent}
      </AlertMessagePrimary>

      <AlertMessagePrimary
        data-test="alertMessagePrimary"
        title={(recurringAlert && recurringAlert.length && recurringAlert[0].field_header) ||"Cancel"}
        className="artCancelRecurring"
        visible={recurringPopup}
        onOk={() => CancelRecurring()}
        onCancel={() => handleRecuringPopup()}
        cancelText={ (recurringAlert && recurringAlert.length && recurringAlert[0].field_alert_button2_text) ||"No, take me back"}
        okText={ (recurringAlert && recurringAlert.length && recurringAlert[0].field_alert_button1_text) ||"CONTINUE"}
      >
        {(props.contents && getAlertDescForActivity(props.contents,'Recurring')) ||WarningContent.recurring}
      </AlertMessagePrimary>
      {props.singleData && props.recurringData && (
        <Row data-test = 'iconsPlaceNew'>
          <IconsPlaceNew  data-test = "iconsPlaceNewelements">
         
          {
            tabIndex === "1" && !((props.avail && props.singleData.allSingleGrants) || !props.avail) && (
              <StyleLessButtons>
                <Preloader styling="btnLoader" />
              </StyleLessButtons>)
          }

          {
           ((tabIndex === "1" && ((props.avail && props.singleData.allSingleGrants) || !props.avail)) || tabIndex === "2" || tabIndex === "3")
           && (
              <StyleLessButtons
                id={`${tabIndex}btnExport`}
                onClick={() => exportGrantsTable(tabIndex)}
              >
                <IconPadding primary={true}>
                  <img src={exportIcon} alt="exportIcon" />
                  <DataExportPrint>EXPORT</DataExportPrint>
                </IconPadding>
              </StyleLessButtons>)
          }
            <PrintComponents
              className="i_print"
              trigger={
                <StyleLessButtons id="btnPrint" className="mobile-view-accountDetails">
                  <IconPadding
                    className="ml2"
                    onClick={() => analyticsTracking("print", tabIndex)}
                  >
                    <img src={printIcon} alt = "printIcon"/>
                    <DataExportPrint>PRINT</DataExportPrint>
                  </IconPadding>
                </StyleLessButtons>
              }
            >
              {tabIndex === "1" && (
                <>
                  <ContentPrinter
                    position="fixed"
                    selectedTabs={"1"}
                    data={
                      printerData.length
                        ? printerData
                        : props.singleData && props.singleData.singleGrants
                    }
                  />
                </>
              )}
              {tabIndex === "2" && (
                <>
                  <ContentPrinter
                    position="absolute"
                    selectedTabs={"2"}
                    data={
                      printerData.length
                        ? printerData
                        : props.recurringData &&
                        props.recurringData.recurringGrant
                    }
                  />
                </>
              )}
              {tabIndex === "3" && (
                <>
                  <ContentPrinter
                    position="fixed"
                    selectedTabs={"3"}
                    data={
                      printerData.length ? printerData : props.agreementsData
                    }
                  />
                </>
              )}
            </PrintComponents>
          </IconsPlaceNew>
          <TabsComponent
            data-test="highlighter"
            tabContent={tabContent}
            getChange={tabController}
            highlighter={highlighter}
            tabIndex={props.grantTab}
            update={checkUpdate}
            updateRec= {checkUpdateRec}
            setPrinter={setPrinter}
            handleColumnChange={(sorter, extra) => columnOnChange(sorter, extra)}
            getDataSource={currentData => getDataSource(currentData)}
            {...props}
          />
           
        </Row>
      )}
    </div>
  );
}

const mapStateToProps = state => ({
  ...ContentComponentDerivedStates(state.toJS())
});


ContentComponent.propTypes = {
  recurringData: PropTypes.object,
  singleData: PropTypes.array,
  lazyLoaded: PropTypes.array,
  lazyLodedRec: PropTypes.array,
  agreementsData:  PropTypes.array,
  csrBusinessFunction: PropTypes.func,
  tab: PropTypes.string,
  cancelTxnSchedule: PropTypes.func,
  setTab: PropTypes.func,
  enableRegrant: PropTypes.func,
  fetchGrantData: PropTypes.func,
  setCSRBusinessData: PropTypes.func,
  page: PropTypes.string,
  contentType: PropTypes.string,
  userData: PropTypes.object,
  updateSingleGrants: PropTypes.func,
  showGaLoader: PropTypes.func,
  setAllSingleGrants: PropTypes.func
}


export const mapDispatchToProps = dispatch => ({
  cancelTxnSchedule: data => dispatch(cancelTxnSchedule(data)),
  setTab: data => dispatch(selectGAtab(data)),
  enableRegrant: data => dispatch(enableRegrant()),
  fetchGrantData: data => dispatch(fetchGrantData(data)),
  setCSRBusinessData: data => dispatch(setCSRBusinessData(data)),
  updateSingleGrants: data => dispatch(updateSingleGrants(data)),
  showGaLoader: () => dispatch(showGaLoader()),
  setAllSingleGrants: data => dispatch(setAllSingleGrants(data)),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(withContents(ContentComponent))
);
